import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export enum NotificationOptionTypes {
  Success = 'success',
  Error = 'error',
  MissingHeaders = 'missing-headers',
}
interface IInitialState {
  isNotificationModalOpen: boolean;
  notificationType: NotificationOptionTypes | null;
  missingFields: string[];
  notificationText: string;
  selectedSpeciesGenus: string | null;
  openAddRecordModal: boolean;
  countryInputValue: string;
  sampleCountInputValue: number | undefined;
  genusTableLoaded: boolean;
  deleteConfirmationMessage: string;
}
const initialState: IInitialState = {
  isNotificationModalOpen: false,
  notificationType: null,
  missingFields: [],
  notificationText: '',
  selectedSpeciesGenus: null,
  openAddRecordModal: false,
  countryInputValue: '',
  sampleCountInputValue: undefined,
  genusTableLoaded: false,
  deleteConfirmationMessage: 'Are you sure you want to delete this record?',
};
export const adminSlice = createSlice({
  name: 'adminSlice',
  initialState,
  reducers: {
    setNotificationModalOpen: (state, action) => {
      state.isNotificationModalOpen = action.payload;
    },

    setNotificationType: (state, action) => {
      state.notificationType = action.payload;
    },
    setMissingFields: (state, action) => {
      state.missingFields = action.payload;
    },
    setNotificationText: (state, action) => {
      state.notificationText = action.payload;
    },
    setSelectedSpeciesGenus: (state, action) => {
      state.selectedSpeciesGenus = action.payload;
    },
    setOpenAddRecordModal: (state, action) => {
      state.openAddRecordModal = action.payload;
    },

    setCountryInputValue: (state, action) => {
      state.countryInputValue = action.payload;
    },
    setSampleCountInputValue: (state, action) => {
      state.sampleCountInputValue = action.payload;
    },

    setGenusTableLoaded: (state, action) => {
      state.genusTableLoaded = action.payload;
    },

    setDeleteConfirmationMessage: (state, action) => {
      state.deleteConfirmationMessage = action.payload;
    },
  },
});

export const {
  setNotificationModalOpen,
  setNotificationType,
  setMissingFields,
  setNotificationText,
  setSelectedSpeciesGenus,
  setOpenAddRecordModal,
  setCountryInputValue,
  setSampleCountInputValue,
  setGenusTableLoaded,
  setDeleteConfirmationMessage,
} = adminSlice.actions;

export const isNotificationModalOpenSelector = (state: RootState) => state.adminSlice.isNotificationModalOpen;
export const notificationTypeSelector = (state: RootState) => state.adminSlice.notificationType;
export const missingFieldsSelector = (state: RootState) => state.adminSlice.missingFields;
export const notificationTextSelector = (state: RootState) => state.adminSlice.notificationText;
export const selectedSpeciesGenusSelector = (state: RootState) => state.adminSlice.selectedSpeciesGenus;
export const openAddRecordModalSelector = (state: RootState) => state.adminSlice.openAddRecordModal;
export const countryInputValueSelector = (state: RootState) => state.adminSlice.countryInputValue;
export const sampleCountInputValueSelector = (state: RootState) => state.adminSlice.sampleCountInputValue;
export const genusTableLoadedSelector = (state: RootState) => state.adminSlice.genusTableLoaded;
export const deleteConfirmationMessageSelector = (state: RootState) => state.adminSlice.deleteConfirmationMessage;

export default adminSlice.reducer;
